import { SimulatorType } from "@/types/api/SimulatorType"

const SIMULATOR_TYPE_VALUES = new Set<string>(Object.values(SimulatorType))

function isSimulatorType(
  value: string | null | undefined,
): value is SimulatorType {
  return value != null && SIMULATOR_TYPE_VALUES.has(value)
}

export function getSimulatorType(
  value: string | null | undefined,
): SimulatorType | null {
  return isSimulatorType(value) ? value : null
}
